import { render, staticRenderFns } from "./MainSliderForRectorat.vue?vue&type=template&id=2a84796e&scoped=true&"
import script from "./MainSliderForRectorat.vue?vue&type=script&lang=js&"
export * from "./MainSliderForRectorat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a84796e",
  null
  
)

export default component.exports